import { setOperationStatus, UI_OPERATION_STATUS_ERROR, UI_OPERATION_STATUS_REQUEST, UI_OPERATION_STATUS_SUCCESS } from '@uncinc/react-drupal-core';
import { commerceLoadCart, commerceFetch } from '@uncinc/react-drupal-core/dist/redux/actions/Commerce';
import { setPrevOrderNumber } from '../UI';

export const commerceCartOrderSetAllInformation = (
  billingCountryCode, billingLocality, billingPostalCode, billingAddressLine1, billingAddressLine2, billingGivenName, billingFamilyName, billingOrganization,
  shippingCountryCode, shippingLocality, shippingPostalCode, shippingAddressLine1, shippingAddressLine2, shippingGivenName, shippingFamilyName, shippingOrganization,
  email, invoiceEmail = null, customerReference = null, telephone = null,
) => {
  return (dispatch, getState) => {
    dispatch(setOperationStatus('commerce', 'cart_checkout', UI_OPERATION_STATUS_REQUEST));
    const cartId = getState().getIn(['commerce', 'cart', 'content', 'id']);
    commerceFetch(`checkout/${cartId}`, 'PATCH', {
      type: 'order--default',
      id: cartId,
      attributes: {
        email: email,
        field_invoice_email: invoiceEmail,
        field_customer_reference: customerReference,
        billing_information: {
          address: {
            country_code: billingCountryCode,
            locality: billingLocality,
            postal_code: billingPostalCode,
            address_line1: billingAddressLine1,
            address_line2: billingAddressLine2,
            given_name: billingGivenName,
            family_name: billingFamilyName,
            organization: billingOrganization,
          },
          field_first_name: billingGivenName,
          field_last_name: billingFamilyName,
          field_telephone: telephone,
        },
        shipping_method: '1--default',
        shipping_information: {
          address: {
            country_code: shippingCountryCode,
            locality: shippingLocality,
            postal_code: shippingPostalCode,
            address_line1: shippingAddressLine1,
            address_line2: shippingAddressLine2,
            given_name: shippingGivenName,
            family_name: shippingFamilyName,
            organization: shippingOrganization,
          },
          field_first_name: billingGivenName,
          field_last_name: billingFamilyName,
          field_telephone: telephone,
        },
      },
    }, dispatch, getState)
      .then((response) => {
        if (!(response.status >= 200 && response.status <= 299)) {
          throw new Error(response.status);
        }
        return response.json();
      })
      .then((response) => {
        dispatch(commerceLoadCart());
        dispatch(setOperationStatus('commerce', 'cart_checkout', UI_OPERATION_STATUS_SUCCESS));
      }).catch(() => {
        dispatch(setOperationStatus('commerce', 'cart_checkout', UI_OPERATION_STATUS_ERROR));
      });
  };
};

export const commerceCartFinishOrder = () => {
  return (dispatch, getState) => {
    dispatch(setOperationStatus('commerce', 'cart_checkout', UI_OPERATION_STATUS_REQUEST));
    const cartId = getState().getIn(['commerce', 'cart', 'content', 'id']);
    commerceFetch(`checkout/${cartId}`, 'PATCH', {
      type: 'order--default',
      id: cartId,
      attributes: {
        state: 'fulfillment',
      },
    }, dispatch, getState).then((response) => {
      if (!(response.status >= 200 && response.status <= 299)) {
        throw new Error(response.status);
      }
      return response.json();
    }).then((response) => {
      dispatch(setPrevOrderNumber(response.data.attributes.order_number));
      dispatch(commerceLoadCart());
      dispatch(setOperationStatus('commerce', 'cart_checkout', UI_OPERATION_STATUS_SUCCESS));
    }).catch(() => {
      dispatch(setOperationStatus('commerce', 'cart_checkout', UI_OPERATION_STATUS_ERROR));
    });
  };
};
